<template>
  <div class="background-container">
    <div class="login-frame">
      <img class="logo" src="@/assets/images/Japan.png" />
      <el-button class="login-btn" @click="navToHomePage">{{
        $t("loginBtn")
      }}</el-button>
      <div>
        <el-radio-group v-model="radio" @change="handleLanguageChange" class="language-selector">
          <el-radio :label="2">English</el-radio>
          <!-- <el-radio :label="3">简体中文</el-radio> -->
          <el-radio :label="4">日本語</el-radio>
        </el-radio-group>
        <div class="language-message">{{ $t('languageMsg') }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.background-container {
  background-size: cover;
  background-position: center;
  background-image: url("@/assets/images/login/TOP.png");
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.login-frame {
  display: flex;
  padding: 2rem;
  padding-bottom: 1rem;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border-radius: 0.75rem;
  background: #fff;
  box-sizing: border-box;
}

.logo {
  max-width: 100%;
  height: auto;
}

.login-btn {
  color: #fff;
  text-align: center;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;
  height: 3rem;
  padding: 0rem 1rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
  --el-button-bg-color: #f36633 !important;
  --el-button-border-color: #f36633 !important;
  --el-button-hover-bg-color: #376f7b !important;
  --el-button-hover-text-color: white !important;
  --el-button-hover-border-color: #376f7b !important;
  --el-button-active-bg-color: #376f7b !important;
  --el-button-active-border-color: #376f7b !important;
  width: 100%;
}

.language-selector {
  display: flex;
  flex-wrap: nowrap;
  max-width: 100%;
  justify-content: center;
}

.language-message {
  color: #868693;
  font-size: 0.75rem;
  text-align: center;
  margin-top: 0.5rem;
}

@media only screen and (max-width: 1200px) {
  .login-frame {
    padding: 1.5rem;
    padding-bottom: 1rem;
    width: 90%;
  }

  .login-btn {
    height: 2.5rem;
    padding: 0rem 0.5rem;
  }

  .el-radio {
    margin-right: 5px !important;
  }
}
</style>

<script lang="ts">
import { defineExpose, ref, inject, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import qs from "qs";
import { AxiosInstance } from "axios";
import { useI18n } from "vue-i18n";
import { saveUserInfo, getUserInfo } from "@/state/UserInfo";
import { ElLoading } from "element-plus";
import { compressBase64Image } from "@/utils/imageCompressor";

export default {
  setup() {
    const axiosInstance = inject("axiosInstance") as AxiosInstance;
    const route = useRoute();
    const router = useRouter();
    const nextUrl = route.query.nextUrl as string;
    if (nextUrl) {
      localStorage.setItem("nextUrl", nextUrl);
    }

    const navToHomePage = () => {
      // sessionStorage.clear();
      let query = {
        client_id: process.env.VUE_APP_CLIENT_ID,
        response_type: "code",
        redirect_uri: location.origin + "/login",
        // redirect_uri: process.env.VUE_APP_REDIRECT_URI,
        scope: process.env.VUE_APP_SCOPE,
        response_mode: "query",
        state: "12345",
      };
      //这里的authorize的地址也需要配置到环境变量
      location.href =
        process.env.VUE_APP_AUTHORIZE_LOCATION + qs.stringify(query);
    };
    onMounted(async () => {
      console.log(code);
      const savedLocale = localStorage.getItem("inhubLocale");
      locale.value = savedLocale || "en";
      if (code != undefined && code != "") {
        // @ts-ignore
        global.loadingInstance = ElLoading.service();
        getAccessToken();
      }
    });

    const getAccessToken = async () => {
      const userInfo = getUserInfo();
      let data = {
        code: code,
        redirect_uri: location.origin + "/login",
        wecom_userid: userInfo?.wecom_userid,
      };
      try {
        const res = await axiosInstance.request({
          url: "api/Token/getAccessToken",
          data: data,
          method: "post",
        });
        axiosInstance.interceptors.request.use((config) => {
          const token = res.data.tokenResult.access_token;
          if (token) {
            config.headers.Authorization = `Bearer ${token}`;
          }
          return config;
        });
        await saveUserInfo(res.data);
        const User = await addUser(
          res.data.graphUserInfo!.displayName,
          res.data.graphUserInfo!.mail,
          res.data.graphUserInfo!.id,
          res.data.graphUserInfo!.jobTitle,
          await compressBase64Image(res.data.graphUserInfo!.avatar),
          res.data.tokenResult.access_token
        );
        res.data.graphUserInfo!.userId = User.UserId;
        res.data.graphUserInfo!.authority = User.Authority;
        res.data.graphUserInfo!.pendingAdmit = User.PendingAdmit;
        if (userInfo?.wecom_userid) {
          res.data.set("wecom_userid", userInfo.wecom_userid);
        }
        await saveUserInfo(res.data);
        // @ts-ignore
        global.loadingInstance.close();
        router.push(localStorage.getItem("nextUrl") || "/");
      } catch (error) {
        console.log(error);
      }
    };

    //获取url中的参数code
    const code = ref(route.query.code).value;

    const radio = ref(2);

    const { locale } = useI18n();
    const handleLanguageChange = (e: any) => {
      // if (e == 3) {
      //   locale.value = "zh";
      // } else if (e == 4) {
      if (e == 4) {
        locale.value = "jp";
      } else {
        locale.value = "en";
      }
      localStorage.setItem("inhubLocale", locale.value);
    };

    const savedLocale = localStorage.getItem("inhubLocale");
    if (savedLocale) {
      locale.value = savedLocale;
      // if (savedLocale == "zh") {
      //   radio.value = 3;
      // } else 
      if (savedLocale == "jp") {
        radio.value = 4;
        console.info("$t(\"loginBtn\")")
      } else {
        radio.value = 2;
      }
    }

    const addUser = (
      UserName: string,
      Email: string,
      MudId: string,
      JobTitle: string,
      Avatar: string,
      access_token: string
    ) => {
      return axiosInstance
        .request({
          url: "api/User/AddUser",
          method: "post",
          data: {
            UserName: window.btoa(unescape(encodeURIComponent(UserName))),
            Email: window.btoa(unescape(encodeURIComponent(Email))),
            MudId: window.btoa(unescape(encodeURIComponent(MudId))),
            JobTitle: (JobTitle != null && JobTitle != "") ? window.btoa(unescape(encodeURIComponent(JobTitle))) : "",
            Avatar: window.btoa(unescape(encodeURIComponent(Avatar))),
          },
          headers: {
            Authorization: "Bearer " + access_token,
          },
        })
        .then((res) => {
          console.log("addUser", res.data);
          return res.data.Data; // return the UserId
        });
    };

    return {
      radio,
      navToHomePage,
      getAccessToken,
      handleLanguageChange,
    };
  },
};
// Wrap your methods and data in defineExpose
defineExpose({});
</script>
